import * as React from 'react';
import { useSelector } from 'react-redux';

import { AiBannerDesktop } from '../../components/AiBanner/AiBannerDesktop';
import { AiBannerMobile } from '../../components/AiBanner/AiBannerMobile';
import { selectAiSummaryEntryPoint } from '../../selectors/newbuildingsCompare';
import { useApplicationContext } from '../../utils/applicationContext';
import { SUMMARY_ENABLED_CONFIG_KEY } from '../../constants/summary';

export interface IAiBannerContainerProps {
  onOpen: () => void;
  mobile?: boolean;
}

export const AiBannerContainer = ({ onOpen, mobile = false }: IAiBannerContainerProps): React.JSX.Element | null => {
  const aiSummaryEntryPoint = useSelector(selectAiSummaryEntryPoint);
  const { config } = useApplicationContext();
  const isAiSummaryEnabled = config.get<boolean>(SUMMARY_ENABLED_CONFIG_KEY);

  if (!aiSummaryEntryPoint || !isAiSummaryEnabled) {
    return null;
  }

  return mobile ? (
    <AiBannerMobile {...aiSummaryEntryPoint} onOpen={onOpen} />
  ) : (
    <AiBannerDesktop {...aiSummaryEntryPoint} onOpen={onOpen} />
  );
};
